import React from 'react';
import { Phone } from 'lucide-react';
import { clinicInfo } from '../data/mockData';

const EmergencyButton = () => {
  return (
    <>
              <a
          href={`tel:${clinicInfo.phone}`}
          className="emergency-button"
          onClick={() => {
            if (window.gtag) {
              window.gtag('event', 'phone_click', {
                event_category: 'conversion',
                event_label: 'Emergency Call Button'
              });
            }
          }}
        >
        <Phone size={18} />
        <span>Dental Emergency? Call Now</span>
      </a>

      <style jsx>{`
        .emergency-button {
          position: fixed;
          top: 100px;
          right: 24px;
          background: #ba3e2b;
          color: white;
          padding: 12px 20px;
          border-radius: 0px;
          display: flex;
          align-items: center;
          gap: 8px;
          text-decoration: none;
          font-size: 14px;
          font-weight: 700;
          font-family: 'Suisse Medium', sans-serif;
          box-shadow: 0 4px 12px rgba(186, 62, 43, 0.3);
          transition: all 0.2s cubic-bezier(.645,.045,.355,1);
          z-index: 999;
        }

        .emergency-button:hover {
          background: #9a3223;
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(186, 62, 43, 0.4);
        }

        @media (max-width: 1024px) {
          .emergency-button {
            top: auto;
            bottom: 100px;
            right: 20px;
            padding: 10px 16px;
            font-size: 13px;
          }

          .emergency-button span {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

export default EmergencyButton;
